import type { PresentationIsEmptyProps } from '../..'

export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  // an image object without a `src` (e.g. just `presentationOptions`) renders nothing (#24160)
  if (!fields.leftImage?.src && !fields.rightImage?.src) {
    return true
  }

  return false
}
